import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import { marketingNavigation } from '../../constants/marketing';
import DealsList from './containers/DealsList/DealsList';
import dealsStore from './store/dealsStore';
import { AVAILABILITY_OPTIONS } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import theme from 'src/constants/styles';
import { appStore } from 'src/mobx/appStore';
import { localeStore } from 'src/mobx/localesStore';
import { getLastArrayItem } from 'src/utils/helpers';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import FullScreenMessage from 'src/view/components/FullScreenMessage/FullScreenMessage';
import MenuManagTabHeader from 'src/view/containers/Headers/containers/MenuManagTabHeader/MenuManagTabHeader';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';

const DealsScreen: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    dealsStore.unMount();

    return () => dealsStore.unMount();
  }, []);

  const setSearch = useCallback((search: string) => {
    dealsStore.setFilters({ search });
  }, []);

  const selectCategory = useCallback((options: IPickerOption[]) => {
    dealsStore.setFilters({ category: getLastArrayItem<IPickerOption>(options) });
  }, []);

  const selectAvailability = useCallback((options: IPickerOption[]) => {
    dealsStore.setFilters({
      availability: getLastArrayItem<IPickerOption>(options)?.value as AVAILABILITY_OPTIONS,
    });
  }, []);

  return (
    <>
      <ScreenHeader title="marketing_role" options={marketingNavigation()} />
      {appStore.settings?.is_pos ? (
        <FullScreenMessage message={localeStore.t('foodics_on_deal_combo')} justify="start" className="px-8 mt-20" iconColor={theme.colors.gray2} />
      ) : (
        <>
          <MenuManagTabHeader
            createPath={SCREENS.DEALS_CREATE()}
            availability={dealsStore.filters.availability}
            search={dealsStore.filters.search}
            loading={dealsStore.isLoading}
            foundItemsInSystem={dealsStore.foundDealsInSystem || Boolean(dealsStore.pagination.data.length)}
            createButtonTitle="create_offer"
            selectAvailability={selectAvailability}
            setSearch={setSearch}
            includeDeleteOption
            includeCategoryPicker
            includeAvailabilityPicker
            selectedCategory={dealsStore.filters.category ? [dealsStore.filters.category] : undefined}
            selectCategory={selectCategory}
          />
          <DealsList />
        </>
      )}
    </>
  );
});

export default DealsScreen;
